import FeatureSubPages from "../../../../src/components/featureSubPages/index.jsx";
import * as React from 'react';
export default {
  FeatureSubPages,
  React
};